// internal
import SEO from "components/seo";
import shape from "assets/img/coming/coming-shape-1.png";
import gif_img from "assets/img/coming/7SCW.gif";
import SocialLinks from "components/social";
import Time from "utils/time";
import { Image } from "react-bootstrap";
import Wrapper from "layout/wrapper";
import HeaderSix from "layout/headers/header-6";
import FooterSeven from "layout/footers/footer-7";

export default function ComingSoon() {
  return (
    <Wrapper>
      <SEO
        metaTitle={"3D Space: Coming Soon"}
        metaDesc={"Get access to download 3D models and 3D animations for free."}
        metaKeywords={"3d space, free 3d models, download 3d models for free, free 3d asset library, free 3d animated models"}
        canonical="https://www.rionick.com/3d-space-announcement"
        pageTitle={"Coming Soon"}
      />
      <HeaderSix />
      <section className="coming__area coming__height d-flex align-items-center">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-7 col-lg-6">
              <div className="coming__content text-start">
                <h3 className="coming__title">
                  Your ticket to 3D Space Adventure is Here!
                </h3>
                {/* Embedded External Link Button */}
                <div className="coming__button mt-4 text-start">
                  <a
                    href="https://3dspace.rionick.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="tp-btnr bg-danger tp-btn-shine-effect text-white px-4 py-2"
                  >
                    Enter to the 3D world!
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-5 col-lg-6">
              <div className="coming__thumb">
                <Image src={gif_img} alt="gif image" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <FooterSeven />
    </Wrapper>
  );
}
